var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "589.000000pt",
    height: "549.000000pt",
    viewBox: "0 0 589.000000 549.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,549.000000) scale(0.100000,-0.100000)",
    fill: "#ced081",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M736 5009 l-267 -262 489 -491 490 -491 11 -490 11 -490 266 -265 265 -265 739 745 739 745 -261 261 -260 261 -226 6 c-125 4 -345 10 -490 13 l-263 7 -487 490 -488 489 -268 -263z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3237 2497 l-736 -744 262 -260 262 -261 445 -11 c245 -6 464 -11 487 -11 l43 0 488 -491 488 -492 268 263 267 264 -489 490 -490 491 -11 490 -12 490 -262 263 c-144 144 -265 262 -268 262 -3 0 -337 -334 -742 -743z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGap);
export default __webpack_public_path__ + "static/media/gap.32d84b974a239a7f16293ebd1ddd0a59.svg";
export { ForwardRef as ReactComponent };